export const Breakpoints = {
  xs: 480,
  sm: 767,
  md: 969,
  lg: 1024,
  xlg: 1280,
  xxlg: 1440,
};

export const Colors = {
  white: '#fff',
  whiteTwo: '#fdfdfd',
  alabaster: '#fcfcfc',
  seashell: '#F1F1F1',
  wildSand: '#F7F7F7',
  whisper: '#ebe8f3',
  mercury: '#E9E9E9',
  bonJour: '#E8E4E4',
  alto: '#D5D5D5',
  altoTwo: '#DFDFDF',
  silver: '#cccccc',
  silverTwo: '#C5C5C5',
  chatelle: '#b8b4cc',
  silverChalice: '#9F9F9F',
  silverChaliceTwo: '#AFAFAF',
  silverChaliceThree: '#b1b1b1',
  gray: '#929292',
  dustyGray: '#9b9b9b',
  doveGray: '#707070',
  boulder: '#7B7B7B',
  scorpion: '#575757',
  scorpionTwo: '#5D5D5D',
  tundora: '#414141',
  mineshaft: '#383838',
  mineShaftTwo: '#262626',
  black: '#000',
  cranberry: '#DB4D84',
  transparent: 'transparent',
  thunderbird: '#D41010',
  apple: '#3CB649',
  supernova: '#ffce00',
};
